import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'

const LogoSection = () => {

    
    const slideLeft = () => {
        const slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft - 500;
    }
    const slideRight = () => {
        const slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft + 500;
    }

    const organizations = [


      {
          "name": "Boys & Girls Club of New Rochelle",
          "link": "http://www.bgcnr.org",
          "logo": "http://nrccs.org/wp-content/uploads/2017/01/BGC.png"
      },
  
      {
          "name": "The YMCA",
          "link": "http://www.nrymca.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2017/01/Y-Red-Logo.jpg"
      },
  
      {
          "name": "New Rochelle Campership Fund",
          "link": "http://www.campership.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2017/01/nrcf.png"
      },
  
      {
          "name": "Songcatchers Inc.",
          "link": "http://www.songcatchers.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/songcatchers-logo.jpg"
      },
  
      {
          "name": "White Plains Hospital",
          "link": "http://www.wphospital.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2017/01/White_Plains_Hospital_Center_1456264.jpg"
      },
  
      {
          "name": "MBK NewRo", /*MBK - My Brothers Keeper of New Rochelle*/
          "link": "http://www.mbknewro.com/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download-2.png"
      },
  
      {
          "name": "New Rochelle Fund for Educational Excellence",
          "link": "http://www.nredfund.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/images.jpg"
      },
  
      {
          "name": "City School District of New Rochelle ",
          "link": "http://www.nred.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/NRLOGO.png"
      },
  
      {
          "name": "Nepperhan Community Center, Inc.",
          "link": "https://www.nepperhan.org",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/neppehan.jpg"
      },
  
      {
          "name": "Meals-on-Wheels of New Rochelle",
          "link": "http://mownewrochelle.org",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/Logo-png-pdf-sample-1.jpg"
      },
  
      {
          "name": "New Rochelle Cares AIP",
          "link": "http://newrochellecares.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/nrcares-aip-logo.png"
      },
      
      {
          "name": "Garito Manor at Union Square",
          "link": "http://www.garitomanor.com/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/logo.gif"
  
      },
  
      {
          "name": "PTA Everychild.onevoice",
          "link": "http://www.nrptac.org", /* Dead Link */
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download-3.png"
      },
  
      {
          "name": "Alzheimer's Association",
          "link": "http://alz.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/logo_alz.jpg"
      },
  
      {
          "name": "Hope Community Services",
          "link": "http://www.hopecommunityservices.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download-5.png"
      },
  
      {
          "name": "United Hebrew of New Rochelle",
          "link": "http://unitedhebrewgeriatric.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download.png"
      },
  
      {
          "name": "Iona University",
          "link": "http://www.iona.edu/Home.aspx",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download-1.png"
      },
  
      {
          "name": "New Rochelle Public Library",
          "link": "http://nrpl.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2017/01/176644a.png"
  
      },
  
      {
          "name": "The Guidance Center of Westchester",
          "link": "http://www.theguidancecenter.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download-1.jpg"
      },
  
      {
          "name": "New Rochelle Day Nursery",
          "link": "http://www.newrochelledaynursery.org/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/download.jpg"
      },
  
      {
          "name": "New Rochelle Ideally Yours",
          "link": "http://www.newrochelleny.com/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/Document-1.png"
      },
  
      {
          "name": "Montefiore New Rochelle Hospital",
          "link": "https://www.montefiorehealthsystem.org/NewRochelle",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/montefiore-logo.png"
      },
  
      {
          "name": "Zonta Club of New Rochelle",
          "link": "http://zontanewrochelle.blogspot.com/",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/page1image1608.jpeg"
      },
  
      {
          "name": "Volunteer New York!",
          "link": "http://volunteernewyork.org",
          "logo": "http://nrccs.org/wp-content/uploads/2015/06/servlet.ImageServer.jpeg"
      }
  
  
    ]
    
    return (
      <div className="relative flex items-center gap-2">

        <button onClick={slideLeft} className="hidden w-24 h-48 hover:bg-slate-600 bg-slate-700 lg:flex items-center justify-center">
          <ChevronLeftIcon className="w-8 h-8" />
        </button>

        <div id="slider" className="w-full h-full overflow-x-scroll whitespace-nowrap scroll-smooth">

          {/* LOGOS */}
          {organizations.map((item, index) => (
            <a href={item.link} target="_blank" rel="noreferrer">
                <img 
                  src={item.logo}
                  className="w-[120px] h-[120px] inline-block p-2 m-2 cursor-pointer hover:scale-105 ease-in-out duration-150 bg-slate-50" 
                  alt={item.name}
                />
            </a>
            ))}

        </div>

        <button onClick={slideRight} className="hidden w-24 h-48 hover:bg-slate-600 bg-slate-700 lg:flex items-center justify-center">
          <ChevronRightIcon className="w-8 h-8" />
        </button>

      </div>
    );
};
  
export default LogoSection;
  